import React from "react";
import {Box} from "@mui/system";
import { passwordStrength } from 'check-password-strength';
import PasswordStrengthIndicator from "../../Onboarding/Signup/CompanySignup/PasswordStrengthIndicator";
import _ from 'lodash';
import {TextField, InputAdornment, IconButton} from "@mui/material";
import {Visibility, VisibilityOff} from "@mui/icons-material";
import styles from "./Styles.module.css"

export default function PasswordGroup({ placeholder, value, handlePasswordChange }) {
    const [keyCount, setKeyCount] = React.useState(0);
    const [showPassword, setShowPassword] = React.useState(false);

    const performAction = (value) => {
        const isValEmpty = !_.isEmpty(value);
        if(isValEmpty) setKeyCount(keyCount + 1);
        handlePasswordChange(value)
    };

    const handleChange = (event) => {
        const value = event.target.value;
        performAction(value);
    };

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return(
        <Box>
            <div>
                <TextField
                    className={styles.textField}
                    InputProps={{
                        classes: { root: styles.textField },
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                    size="small"
                                >
                                    {showPassword ?
                                        <VisibilityOff sx={{width: '20px', height: '20px'}} /> :
                                        <Visibility sx={{width: '20px', height: '20px'}} />}
                                </IconButton>
                            </InputAdornment>
                        )
                    }}
                    FormHelperTextProps={{ className: styles.helperText }}
                    id="password"
                    name="password"
                    variant="outlined"
                    onChange={handleChange}
                    type={showPassword ? 'text' : 'password'}
                    placeholder={placeholder}
                />
            </div>

            <Box sx={{marginTop: keyCount > 0 ? '15px' : ''}}>
                <PasswordStrengthIndicator
                    value={value}
                    isVisible={keyCount > 0}
                    passwordStrength={passwordStrength(value)}
                    meta={{}} />
            </Box>
        </Box>
    )
}